import React from "react";
/* css comes in adminMember.css */
import Form from "react-bootstrap/Form";
import { IP } from "../../../../../../internalServer";

import { Box, Typography, Chip, Avatar, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

function IndividualsMemberForStudents({
  student,
  setIsMemberUpdated,
  inEditingMode,
  setDeletingAllMembersDetails,
  deletingAllMembersDetails,
}) {
  const { deletingStudents } = deletingAllMembersDetails;
  const handleDeleteMember = () => {
    if (deletingStudents.includes(student.id)) {
      const newStudentsList = deletingStudents.filter((a) => a !== student.id);
      setDeletingAllMembersDetails((prevState) => ({
        ...prevState,
        deletingStudents: newStudentsList,
      }));
    } else {
      setDeletingAllMembersDetails((prev) => ({
        ...prev,
        deletingStudents: [...prev.deletingStudents, student.id],
      }));
    }
    setIsMemberUpdated(true);
  };

  return (
    // <>
    //   <div className="col-12 p-0 d-flex align-items-center justify-content-between orange-scrollBar ">
    //     <div className="col-4 p-0 mt-3 gap-2 d-flex align-items-center">
    //       <div className="member_account_img d-flex align-items-center justify-content-center">
    //         {!student?.student?.profile_picture ? (
    //           <span>{student.student.name.charAt(0).toUpperCase()}</span>
    //         ) : (
    //           <img
    //             src={`${IP}${student?.student?.profilePicture.substring(
    //               student?.student?.profilePicture.indexOf("/")
    //             )}`}
    //             alt=""
    //           />
    //         )}
    //       </div>
    //       <span>{student?.student?.name}</span>
    //     </div>

    //     <div className="mt-3 gap-3 d-flex">
    //       <span>Member</span>
    //       {inEditingMode && (
    //         <>
    //           {!deletingStudents.includes(student.id) ? (
    //             <img
    //               onClick={handleDeleteMember}
    //               src="/images/Dustbin.svg"
    //               alt=""
    //             />
    //           ) : (
    //             <img
    //               onClick={handleDeleteMember}
    //               src="/images/redDustbin.svg"
    //               alt=""
    //             />
    //           )}
    //         </>
    //       )}
    //     </div>
    //   </div>
    // </>

    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1.5,
        borderRadius: 2,
        mb: 1,
        backgroundColor: "background.paper",
        "&:hover": {
          backgroundColor: "#f9f9f9", // light gray hover
        },
      }}
    >
      {/* Left section */}
      <Box display="flex" alignItems="center" gap={2}>
        {/* Avatar */}
        <Avatar
          sx={{
            width: 36,
            height: 36,
            bgcolor: "orange",
            fontWeight: 600,
          }}
          src={
            student?.student?.profilePicture
              ? `${IP}${student?.student?.profilePicture.substring(
                  student?.student?.profilePicture.indexOf("/")
                )}`
              : undefined
          }
        >
          {!student?.student?.profilePicture &&
            student?.student?.name?.charAt(0)?.toUpperCase()}
        </Avatar>

        {/* Name */}
        <Typography fontWeight={500}>{student?.student?.name}</Typography>
      </Box>

      {/* Right section */}
      <Box display="flex" alignItems="center" gap={2}>
        <Chip
          label="Member"
          size="small"
          color="default"
          variant="outlined"
          sx={{ borderRadius: 1 }}
        />

        {inEditingMode && (
          <IconButton onClick={handleDeleteMember} size="small">
            {deletingStudents.includes(student.id) ? (
              <DeleteIcon sx={{ color: "error.main" }} />
            ) : (
              <DeleteOutlineIcon />
            )}
          </IconButton>
        )}
      </Box>
    </Box>
  );
}

export default IndividualsMemberForStudents;
